import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}users`;

// Helper untuk mendapatkan token
const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    };
};

// Service untuk user dengan pagination
export const userService = {
    // Get all user dengan pagination
    getPaginate: async (queryString) => {
        try {
            const response = await axios.get(`${API_URL_WEB}/paginate?${queryString}`, getAuthHeader());
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to fetch user',
                status: error.response?.status,
            };
        }
    },

    // Get all user (tanpa pagination - untuk kompatibilitas)
    getAll: async () => {
        try {
            const response = await axios.get(API_URL_WEB, getAuthHeader());
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to fetch user',
            };
        }
    },

    // Get by ID
    getById: async (id) => {
        try {
            const response = await axios.get(`${API_URL_WEB}/${id}`, getAuthHeader());
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to fetch user by ID',
            };
        }
    },

    // Create user
    create: async (userData) => {
        try {
            const response = await axios.post(API_URL_WEB, userData, getAuthHeader());
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to create user',
                validationErrors: error.response?.data?.errors,
            };
        }
    },

    // Update user
    update: async (id, userData) => {
        try {
            const response = await axios.patch(`${API_URL_WEB}/${id}`, userData, getAuthHeader());
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to update user',
                validationErrors: error.response?.data?.errors,
            };
        }
    },

    // Delete user
    delete: async (id) => {
        try {
            await axios.delete(`${API_URL_WEB}/${id}`, getAuthHeader());
            return {
                success: true,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to delete user',
            };
        }
    },

    // Update active status
    updateActive: async (id, status) => {
        try {
            const response = await axios.patch(
                `${API_URL_WEB}/active-age-group/${id}`,
                { status },
                getAuthHeader()
            );
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to update active status',
            };
        }
    },

    syncDataDokter: async () => {
        try {
            const response = await axios.get(`${API_URL_WEB}/dokter/sync-data-dokter`, null, getAuthHeader());
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to sync dokter',
            };
        }
    }
};

// Export untuk kompatibilitas dengan kode lama
export const getUsers = () => {
    const token = localStorage.getItem('token');
    return axios.get(API_URL_WEB, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    });
};

export const getUserById = (id) => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    });
};

export const createUser = (user) => {
    const token = localStorage.getItem('token');
    return axios.post(API_URL_WEB, user, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    });
};

export const updateUser = (id, user) => {
    const token = localStorage.getItem('token');
    return axios.patch(`${API_URL_WEB}/${id}`, user, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    });
};

export const deleteUser = (id) => {
    const token = localStorage.getItem('token');
    return axios.delete(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export const updateActive = (id, status) => {
    const token = localStorage.getItem('token');
    return axios.patch(`${API_URL_WEB}/user-status/${id}`, { status }, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    });
};

export const syncDataDokter = () => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL_WEB}/dokter/sync-data-dokter`, null, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    });
}